import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'
import { MoySkladProductsTable } from '../../MoySkladProductsTable'

export const MoySkladProductsTableScreen =
  observer(
    () => {

      return (
        <Box width="calc(100vw - 300px)">
          <MoySkladProductsTable/>
        </Box>
      )
    })